module.exports = __webpack_public_path__ + "static/media/01_Mobilversion_Web_Q15_20170806_44day_2124AT.jpg.1d4b24a7.jpg";